import { AlertTriangle } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export const WarningBlock = ({ testId = "third-party-warning", className = "" }) => {
  const { t } = useI18n();
  return (
    <aside
      role="alert"
      className={`flex gap-4 rounded-2xl border-2 border-amber-400/70 bg-[rgba(66,40,0,0.55)] p-4 text-amber-50 sm:p-5 ${className}`}
      data-testid={testId}
    >
      <span className="relative mt-0.5 h-10 w-10 shrink-0">
        <AlertTriangle className="h-10 w-10 fill-amber-400 text-black" strokeWidth={1.75} aria-hidden="true" />
      </span>
      <p className="min-w-0 text-sm leading-relaxed" data-testid={`${testId}-text`}>{t("warn.text")}</p>
    </aside>
  );
};
